import TextField from 'components/TextField';
import { assoc } from 'ramda';

const RoleTextField = ({ input, inputValue, ...otherProps }) => {
  const fieldValue = input.value === 'any' ? inputValue : input.value;
  return (
    <TextField
      input={assoc('value', fieldValue, input)}
      size='100'
      {...otherProps}
    />
  );
};

export default RoleTextField;
